import { render, staticRenderFns } from "./CompProfileBasicInformation.vue?vue&type=template&id=c4651d96&scoped=true"
import script from "./CompProfileBasicInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileBasicInformation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4651d96",
  null
  
)

export default component.exports